import React from 'react';

import Grid from '@components/Grid';

// styles
import s from './SkeletonProductsFeed.sss';

type SkeletonProductsFeedProps = {
  count: number;
};

export const SkeletonProductsFeed: React.FC<SkeletonProductsFeedProps> = ({
  count,
}) => {
  const placeholders = [];
  for (let i = 0; i < count; i += 1) {
    placeholders.push(
      <Grid
        key={i}
        desktop="2_4"
        tablet={4}
        def={6}
      >
        <div className={s.imagePreloader} />
        <div className={s.actionButtonPreloader} />
      </Grid>,
    );
  }
  return (
    <Grid container={true} spacing={10}>
      {placeholders}
    </Grid>
  );
};
